module.exports = __webpack_public_path__ + "assets/c546cc62765711bb1880d61db1d5ce9d.mp3";